


















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'brand-component',
})
export default class BrandComponent extends Vue {
  @Prop({
    type: String,
    default: '',
  })
  protected brandImageUrl: string | undefined;
}
